import React from "react";
import { Col, Row } from "react-bootstrap";
import question from "../../Assets/Images/question.svg";
import "../../Assets/Styles/pages/landing.scss";
import { useTranslation } from "react-i18next";
import { faqs } from "../../Config/features";
import ButtonRounded from "../Signature/button";
const Questions = ({ property, handlePage, searchString = "" }) => {
  const { t } = useTranslation();

  const handleQuestions = () => {
    handlePage("/faq");
  };
  return (
    <Row className="m-0 text-black py-5 px-lg-5 px-4 m-2 my-3 d-flex justify-content-between ">
      {property === "pricing" && (
        <Row className=" text-center d-flex justify-content-center align-items-center m-0 p-0  productSansBold">
          <p className="m-0 text_40 line_height_100pc">
            {t("FAQTitle")}
            <span className="mx-2 CenturyGothicB landing_banner_Heading">
              {t("FAQTitlespan")}
            </span>
          </p>
        </Row>
      )}
      {faqs?.map((faq, i) =>
        faq.type === property &&
        (t(faq.question)
          .toLowerCase()
          .includes(searchString.toLocaleLowerCase()) ||
          t(faq.answer)
            .toLowerCase()
            .includes(searchString.toLocaleLowerCase()) ||
          searchString === "") ? (
          <Row
            key={i}
            className="FAQS w-xs-100 w-50 my-4 py-3 text-start p-0 m-0"
          >
            <Col
              xs={1}
              lg={1}
              className="p-0 me-3 mt-1 d-flex justify-content-center align-items-start"
            >
              <img alt="question" className="size_38x38 " src={question} />
            </Col>
            <Col className="mx-4 p-0 d-flex flex-column align-items-center align-items-lg-start">
              <Row className="text_22 mb-3 pb-2 my-lg-0 productSans">
                {t(faq.question)}
              </Row>
              <Row className="text_16 text-start mb-3 mb-lg-0 productSansLight line_height_1_726">
                {t(faq.answer)}
              </Row>
            </Col>
          </Row>
        ) : null
      )}

      {property === "pricing" ? (
        <Col className="p-3 w-100 pb-0 d-flex align-items-end justify-content-center">
          <ButtonRounded
            onclick={handleQuestions}
            text={"ViewAll1"}
            style={"w_edit_button  my-3 mb-2"}
            parrentStyle={""}
          />
          {/* <button
                        onClick={handleQuestions}
                        className={`Aktiv button_text m-0 px-5 py-2 text_18 border-0 donebutton d-flex justify-content-center align-items-center button_text_signin`}>
                        {t("ViewAll1")}
                    </button> */}
        </Col>
      ) : null}
    </Row>
  );
};

export default Questions;
